module.exports = __webpack_public_path__ + "img/inter-back-mob.3d779bd8.svg";